const lowerCaseMatch = (input: string, value: string) =>
  value.toLowerCase().includes(input.toLowerCase());

export default lowerCaseMatch;
